import {parseAgendaDate} from "@/agenda/lib/agendaTime";
import {MemberDay} from "@/planning/lib/weekPlanning";
import {formatTime, initialsOfName, memberColor, toMinutes} from "@/team/planning";

export interface AgendaPresenceRange {
    /** Minutes of the day, wall clock. */
    start: number;
    end: number;
    /** "9h–12h30", for the tooltip. */
    label: string;
}

/** One member of the presence rail of the agenda day view. */
export interface AgendaPresenceLane {
    key: number;
    name: string;
    initials: string;
    /** Role color of the planning, gray fallback. */
    color: string;
    /** Currently inside one of their ranges (today only). */
    presentNow: boolean;
    ranges: AgendaPresenceRange[];
}

/**
 * The members working the displayed day, as rail items. Resolved days come
 * from the planning resolver, so the rail can never disagree with the
 * Planning screen.
 */
export const buildPresenceLanes = (days: MemberDay[], now: Date): AgendaPresenceLane[] => {
    const current = parseAgendaDate(now);
    const nowMinutes = current.hour() * 60 + current.minute();

    return days
        .filter(day => day.ranges.length)
        .map(day => {
            // Not the shared fallback: here the access has no user at all,
            // rather than having left the team.
            const name = day.member.user?.name ?? 'Membre sans compte';

            return {
                key: day.member.id,
                name,
                initials: initialsOfName(name),
                color: memberColor(day.member),
                presentNow: day.date.isSame(current, 'day')
                    && day.ranges.some(range => toMinutes(range.starts_at) <= nowMinutes && nowMinutes < toMinutes(range.ends_at)),
                ranges: day.ranges.map(range => ({
                    start: toMinutes(range.starts_at),
                    end: toMinutes(range.ends_at),
                    label: `${formatTime(range.starts_at)}–${formatTime(range.ends_at)}`,
                })),
            };
        });
};
